import React from 'react';

interface SettingsItemCardProps {
  icon: React.ElementType;
  name: string;
}

const SettingsItemCard = ({ icon: Icon, name }: SettingsItemCardProps) => {
  return (
    <div className="flex gap-2 items-center py-1">
      <Icon className="text-[1.6rem]" />
      <div>{name}</div>
    </div>
  );
};

export default SettingsItemCard;